import { render, staticRenderFns } from "./FaqScalableDescription.vue?vue&type=template&id=1bde7e74&"
import script from "./FaqScalableDescription.vue?vue&type=script&lang=js&"
export * from "./FaqScalableDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports